import React, { useEffect, useState } from 'react'
import Header from '../../../components/Header'
import SearchInput from '../../../components/SearchInput'
import { authAxios } from '../../../helpers/axios'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import ManageOrder from '../../order/components/ManageOrder'
import { ErrorToast, InfoToast } from '../../../helpers/toasters'
import { LIMIT } from '../../../helpers/constants'
import RightIcon from '../../../images/right.svg'
import SortIcon from '../../../images/sort.svg'
import FilterIcon from '../../../images/filter.svg'
import FilterActiveIcon from '../../../images/filteractive.svg'
import FilterOrder from './RetailerOrderFilter'
import { getDateFormat, getTimeFormat } from '../../../helpers/utils'
import AddProduct from './AddProduct'
import ManageBom from './ManageBom'
import ModalImage from 'react-modal-image'
import EditProductCommonBom from './EditProductCommonBom'
import AddBomToProduct from './AddBomToProduct'
import DeleteProduct from './DeleteProduct'
import {IoIosAddCircleOutline, IoIosArrowDropright, IoIosTrash} from 'react-icons/io'
import {FaTrashAlt} from 'react-icons/fa'
import { IoAddCircleOutline, IoTrashBinOutline, IoTrashOutline } from 'react-icons/io5'
import AddProductVersion from './AddProductVersion'

export default function BuyerProducts({id,showAddProduct,setShowAddProduct}) {

    const [searchText,setSearchText] = useState('')
    const [reps,setOrders] = useState([])
    const [showManage,setShowManage] = useState({status:false,edit:null})
    const [showManageBom,setShowManageBom] = useState({status:false,edit:null})
    const [vieworder,setVieworder] = useState(false)
    const [sort,setSort] = useState('-createdOn')

    const [cityFilters,setCityFilters] = useState([])
    const [routeFilters,setRouteFilters] = useState([])
    const navigate = useNavigate()
    const [offset,setOffset] = useState(0);
    const [count,setCount] = useState(5)
    const [summary,setSummary] = useState({})
    const [filters,setFilters] = useState({routeId:null,cityId:null,status:null,salesRepId:null,retailerId:id,startDate:null,endDate:null})
    const [showFilters,setShowFilters] = useState(false)
    const [expandedRow, setExpandedRow] = useState(null);
    const [showEditCommonBom,setShowEditCommonBom] = useState(false)

    const [selectedFilters,setSelectedFilters] = useState({city:'',route:''})
    const [showAddBom,setShowAddBom] = useState({status:false,id:null})
    const [submitLoading,setSubmitLoading] = useState(false)
    const [showDelete,setShowDelete] = useState(false)
    const [showAddVersion,setShowAddVersion] = useState({status:false,id:null})
    // const [submitting,setSubmitting] = useState(false)

    async function getProducts(){

        try 
        {
            console.log('filters',filters)
            let query = `limit=${LIMIT}&offset=${offset}&search=${searchText}&populate=false&orderBy=${sort}&buyerId=${id}`;
            // query+=``
            // if(filters.cityId) query+=`&cityId=${filters.cityId.id}`
            // if(filters.routeId) query+=`&routeId=${filters.routeId.id}`
            // if(filters.distributorId) query+=`&distributorId=${filters.distributorId.id}`
            // if(filters.salesRepId) query+=`&salesRepId=${filters.salesRepId.id}`
            // if(filters.teamId) query+=`&salesTeamId=${filters.teamId.id}`
            // if(filters.status) query+=`&orderStatus=${filters.status}`
            // if(filters.startDate) query+=`&startDate=${`${new Date(filters.startDate).getDate()}-${new Date(filters.startDate).getMonth()+1}-${new Date(filters.startDate).getFullYear()}`}`
            // if(filters.endDate) query+=`&endDate=${`${new Date(filters.endDate).getDate()}-${new Date(filters.endDate).getMonth()+1}-${new Date(filters.endDate).getFullYear()}`}`
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/product?${query}`)
            // console.log('salse',res.data.data)
            setOrders(res.data.rows)
            setCount(res.data.totalCount)
            // setSummary(res.data.summary)
        } catch (error) {
            console.log(error)
            toast('Error getting orders')
        }
    } 

    const onFilterSubmit = (filters)=>
    {
        try 
        {
            setFilters({...filters})
            setCount(5)
            setOffset(0)
            setShowFilters(false)
        } catch (error) {
            toast('Order Filtered')
        }
    }

    const clearFilter = ()=>
    {
        try 
        {
            setFilters({routeId:null,cityId:null,status:null,distributorId:null,retailerId:null,teamId:null,salesRepId:null,startDate:null,endDate:null})
            setShowFilters(false)
        } catch (error) {
            toast('Order Filtered')
        }
    }



    useEffect(()=>
    {
        getProducts();
    },[offset,searchText,filters,sort])


    const onSubmit = async(e,data,croppedImage)=>
    {
        try 
        {
            e.preventDefault()
            setSubmitLoading(true)
            let imageRes;
            if(croppedImage)
            {
                let formData = new FormData();
                formData.append('file',croppedImage)
                imageRes = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/upload`,formData,{                headers: {
            'content-type': 'multipart/form-data'}})
            } 

            let res;
            if(showAddProduct.edit)
            {
                res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/product/${showAddProduct.item.id}`,{image:imageRes ? imageRes.data : data.image,name:data.name,sku:data.sku,weight:data.weight,quantityPerCarton:data.quantityPerCarton,rate:data.rate})
                await getProducts()
            }
            else
            {
                res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/product`,{...data,buyerId:id,image:imageRes.data}) 
                await getProducts()
                InfoToast('Product Added')
            }
            setShowAddProduct({edit:null,status:false})
            setSubmitLoading(false)
        } catch (error) {
            ErrorToast(error.response.error)
            setSubmitLoading(false)
        }
    }
 
    const onBomUpdate = async(e,data,croppedImage)=>
    {
        try 
        {
            e.preventDefault()
            let imageRes;
            setSubmitLoading(true)
            if(croppedImage)
            {
                let formData = new FormData();
                formData.append('file',croppedImage)
                imageRes = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/upload`,formData,{headers: {
            'content-type': 'multipart/form-data'}})
            } 

            // let res;
            // if(showCreate.edit)
            // {
                let updateData = croppedImage ? {...data,image:imageRes.data} : {...data};
            // let base64Image = await getBase64Image(data.retailerShopImage)
            let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/product/bom/${data.id}`,updateData) 
            await getProducts()
            InfoToast('BOM Updated')
            setShowManageBom({edit:null,status:false})
            setSubmitLoading(false)
        } catch (error) {
            setSubmitLoading(false)
            ErrorToast('Error Updating Image')
        }
    }

    const onCommonBomUpdate = async(e,data)=>
        {
            try 
            {
                e.preventDefault()
                setSubmitLoading(true)
                let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/product/common-bom/${data.id}`,data) 
                await getProducts()
                InfoToast('Common BOM Updated')
                setShowEditCommonBom({edit:null,status:false})
                setSubmitLoading(false)
            } catch (error) {
                setSubmitLoading(false)
                ErrorToast('Error Updating Common BOM')
            }
        }


    const onProductDelete = async(e,id)=>
    {
        try 
        {
            e.preventDefault()
            setSubmitLoading(true)
            let res = await authAxios.delete(`${process.env.REACT_APP_BASE_URL}/product/${id}`)  
            getProducts()
            setShowDelete(false)
            setSubmitLoading(false)
            InfoToast('Product Deleted')
        } catch (error) {
            setSubmitLoading(false)
            ErrorToast('Error Deleting Product')
        }
    }

    const onSortPress = (type)=>
    {
        if (sort === type) {
            if(sort === `-${type}`) setSort(type)
            else setSort(`-${type}`);
          } else {
            setSort(type);
          }
    }
    
    const toggleRow = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
      };

      const onAddBom = async(e,data)=>
        {
            try 
            {
                e.preventDefault()
                setSubmitLoading(true)
                let res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/product/bom/${showAddBom.id}`,data)
                await getProducts()
                setShowAddBom({status:false,type:null})
                setSubmitLoading(false)
                InfoToast('BOM Added')
            } catch (error) 
            {
                setSubmitLoading(false)
                ErrorToast(error.response.data.error)
            }
        }
        


    const onAddVersionSubmit = async(e,id,data)=>
    {
        try 
        {
            e.preventDefault()
            let res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/product/version/${id}`,data)
            await getProducts()
            setShowAddVersion({status:false,type:null})
            setSubmitLoading(false)
            InfoToast('Version Added')
        } catch (error) {
            setSubmitLoading(false)
            ErrorToast(error.response.data.error)
        }
    }

  return (
    <div className='w-full overflow-scroll flex flex-col'>
    <div>
          <div className='h-full flex justify-between items-stretch border-b border-[#e3e3e3] bg-white'>
            <div className='flex'>
                <SearchInput value={searchText} setValue={(value)=>setSearchText(value)} placeholder={'Search order'} label={'Search order'} />
                <div className='flex w-full border-r items-center h-full justify-center text-center'>
                    <div
                        className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center'
                        onClick={() => {
                        if (offset > 0) {
                            setOffset(offset - LIMIT);
                        }
                        }}
                    >
                        <img src={RightIcon} className='w-[20px] h-[20px] rotate-180' alt='Previous Page' />
                    </div>
                    <p className='text-xs whitespace-nowrap w-[80px] justify-center'>{offset + 1}-{Math.min(offset + LIMIT, count)} of {count}</p>
                    <div
                        className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center'
                        onClick={() => {
                        if (offset + LIMIT < count) {
                            setOffset(offset + LIMIT);
                        }
                        }}
                    >
                        <img src={RightIcon} className='w-[20px] h-[20px]' alt='Next Page' />
                    </div>
                    </div>
            </div>
            <div className='flex justify-end h-[100%] self-stretch items-center px-4 border-l border-[#e3e3e3] hover:bg-[#f6f6f6] cursor-pointer' onClick={()=>setShowFilters(true)}>
            {(filters.cityId || filters.routeId || filters.distributorId || filters.teamId || filters.salesRepId || filters.startDate || filters.endDate) ? <img src={FilterActiveIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> : <img src={FilterIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> }
            </div>
        </div>
        </div>
        <div className=' bg-white w-full flex-1 flex overflow-scroll'>
            <table className=' table-auto w-full flex-1'>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                

                    <td><p onClick={()=>onSortPress('name')} className='cursor-pointer flex items-center hover:text-black'>Product Name {sort === 'name' || sort === '-name'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>onSortPress('weight')} className='cursor-pointer flex items-center hover:text-black'>Product Weight {sort === 'weight' || sort === '-weight'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    <td><p onClick={()=>onSortPress('buyer')} className='cursor-pointer flex items-center hover:text-black'>Buyer {sort === 'buyer' || sort === '-buyer'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    
                    <td><p onClick={()=>onSortPress('bom')} className='cursor-pointer flex items-center hover:text-black'>BOMs {sort === 'bom' || sort === '-bom'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('quantityPerCarton')} className='cursor-pointer flex items-center hover:text-black'>Qty Per Carton {sort === 'quantityPerCarton' || sort === '-quantityPerCarton'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    {/* <td><p onClick={()=>onSortPress('createdOn')} className='cursor-pointer flex items-center hover:text-black'>Ordered On {sort === 'createdOn' || sort === '-createdOn'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td> */}

                    <td><p onClick={()=>onSortPress('qty')} className='cursor-pointer flex items-center hover:text-black'>Action {sort === 'qty' || sort === '-qty'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>

                    {/* <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status {sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td> */}
                    {/* <td><p>Action</p></td> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        reps.map((item,index)=>
                        {
                            return <><tr onClick={()=>toggleRow(item.id)}>
                                <td className='capitalize relative'>
                                    <div className='flex items-center absolute top-0 left-0 opacity-90'>
                                        <p className='text-xs font-medium bg-[#2ac08b] text-white px-2 py-1 rounded-[4px] rounded-tl-none'>V{item.currentVersion}</p>
                                    </div>
                                    <div className='flex items-center'>
                                    <div className="image-preview mr-2 ">
                                        <ModalImage small={`${process.env.REACT_APP_STATIC_URL}/${item.image}`} medium={`${process.env.REACT_APP_STATIC_URL}/${item.image}`} alt={item.name} className="rounded-full h-[32px] w-[32px] image-preview inline-block"/>
                                    </div>
                                        <p className='text-sm font-medium my-0'>{item.name}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.weight} Gms</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.buyer?.name}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                  <p className='text-sm font-medium my-0'>{parseInt(item.bom?.length)}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                  <p className='text-sm font-medium my-0'>{parseInt(item.quantityPerCarton)}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        {/* <button className='btn-xs' onClick={()=>setShowAddProduct({status:true,edit:true,item:item})}>Edit Product</button> */}
                                        <button className='btn-xs border-0 p-0 hover:bg-transparent group' onClick={()=>setShowAddBom({status:true,id:item.id})}><IoIosArrowDropright className='w-[24px] h-[24px] mr-2 text-[#000] hover:text-[#2ac08b]' /></button>
                                        <button className='btn-xs border-0 p-0 hover:bg-transparent group' onClick={()=>setShowAddVersion({status:true,id:item.id})}><IoAddCircleOutline className='w-[24px] h-[24px] mr-2 text-[#000] hover:text-[#2ac08b]' /></button>
                                        <button className='btn-xs border-0 p-0 hover:bg-transparent group' onClick={()=>setShowDelete({status:true,id:item.id})}><IoTrashOutline className='w-[24px] h-[24px] text-[#000] hover:text-[#ff0000]' /></button>
                                    </div>
                                </td>
                            </tr>
                            {expandedRow === item.id && (
                            <tr>
                                <td colSpan={5} className='px-0 bg-gray-50'>
                                <div className='w-full'>
                                    <table>
                                        <tbody>
                                            {
                                                item.bom.map((it,i)=>
                                                {
                                                    return <tr key={i} className='py-0 border-b-0'>
                                                        <td colSpan={2} className='py-0 pl-16'>
                                                        <div className="image-preview mr-2 ">
                                        <ModalImage small={`${process.env.REACT_APP_STATIC_URL}/${it.image}`} medium={`${process.env.REACT_APP_STATIC_URL}/${it.image}`} alt={it.name} className="rounded-full h-[32px] w-[32px] image-preview inline-block"/>
                                    </div>
                                                            <p className='text-xs font-medium'>{it.name}</p>
                                                        </td>
                                                        <td>
                                                        <p className='text-xs font-medium'>Product BOM</p>
                                                        </td>
                                                        <td><p className='text-xs font-medium'>{it.shared === 1 ? 'Shared BOM' : it.shared === 2 ? 'Shared Weight' :  'Unique BOM'}</p></td>
                                                        <td><p className='text-xs font-medium'>{it.shared === 1 ? `Shared: ${it.quantity}` : it.shared === 2 ? `Shared Weight: ${it.quantity} Gms` :  `Qty. ${it.quantity}`}</p></td>
                                                        <td><p className='text-xs font-medium'>In Stock:{it.stock}</p></td>
                                                        <td className='capitalize'>
                                {/* <div>
                                        <button className='btn-xs' onClick={()=>setShowManageBom({status:true,edit:it})}>Edit BOM</button>
                                    </div> */}
                                </td>
                                                    </tr>
                                                })
                                            }
                                            {
                                                item.productCommonBoms?.map((it,i)=>
                                                {
                                                    return <tr key={i} className='py-0 border-b-0'>
                                                        <td colSpan={2} className='py-0 pl-16'>
                                                        <div className="image-preview mr-2 ">
                                        <ModalImage small={`${process.env.REACT_APP_STATIC_URL}/${it.image}`} medium={`${process.env.REACT_APP_STATIC_URL}/${it.image}`} alt={it.name} className="rounded-full h-[32px] w-[32px] image-preview inline-block"/>
                                    </div>
                                                            <p className='text-xs font-medium'>{it.commonBom.name}</p>
                                                        </td>
                                                        <td>
                                                        <p className='text-xs font-medium'>Common BOM</p>
                                                        </td>
                                                        <td><p className='text-xs font-medium'>{it.shared === 1 ? 'Shared BOM' : it.shared === 2 ? 'Shared Weight' :  'Unique BOM'}</p></td>
                                                        <td><p className='text-xs font-medium'>{it.shared === 1 ? `Shared: ${it.quantity}` : it.shared === 2 ? `Shared Weight: ${it.quantity} Gms` :  `Qty. ${it.quantity}`}</p></td>
                                                        <td><p className='text-xs font-medium'>In Stock:{it.commonBom.stock}</p></td>
                                                        <td className='capitalize'>
                                {/* <div>
                                        <button className='btn-xs' onClick={()=>setShowEditCommonBom({status:true,edit:it})}>Edit BOM</button>
                                        
                                    </div> */}
                                </td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                </td>
                            </tr>
                            )}
                            </>
                        })
                    }
                </tbody>
            </table>
        </div>
        {/* <div className=' flex justify-between items-stretch border-t border-[#e3e3e3] bg-white w-full'>
            <div className='flex px-6 py-2 justify-between w-full'>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total/Cancelled/Pending/Finished-{count}/{summary.cancelledOrders}/{summary.pendingOrders}/{summary.finishedOrders}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Points - {summary.totalPoints}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Weight - {(summary.totalWeight/1000).toFixed(2)}Kgs</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Amount - {summary.totalAmount}</p>
                <p className='text-[13px] text-gray-600 font-medium my-0'>Total Qty - {summary.totalQty}</p>
            </div>
        </div> */}
        { showAddProduct.status ? <AddProduct submitLoading={submitLoading} onClose={setShowAddProduct} onSubmit={onSubmit} edit={showAddProduct.edit} updateData={showAddProduct.item}/> : null}
        { showManageBom.status ? <ManageBom updateData={showManageBom.edit} onClose={setShowManageBom} onSubmit={onBomUpdate} edit={true}/> : null}
        {/* { vieworder ? <ViewOrder getProducts={getProducts} onClose={setVieworder} id={vieworder}/> : null} */}
        { showFilters ? <FilterOrder onSubmit={onFilterSubmit} id={vieworder} filters={filters} onClose={setShowFilters} clearFilter={clearFilter}/> : null}

        {showEditCommonBom.status ? <EditProductCommonBom updateData={showEditCommonBom.edit} onClose={setShowEditCommonBom} onSubmit={onCommonBomUpdate} edit={true}/> : null}

        {showAddBom.status ? <AddBomToProduct submitLoading={submitLoading} onClose={setShowAddBom} onSubmit={onAddBom}/> : null}
        
        
        {showDelete.status ? <DeleteProduct id={showDelete.id} submitLoading={submitLoading} onClose={setShowDelete} onSubmit={onProductDelete}/> : null}
        {
            showAddVersion.status ? <AddProductVersion submitLoading={submitLoading} onClose={setShowAddVersion} onSubmit={onAddVersionSubmit} id={showAddVersion.id}/> : null
        }
    </div>
  )
}

